import React from 'react';
import { signOut, useSession } from 'next-auth/react';
import { useLazyQuery } from '@apollo/client';
import { User } from '../models';
import { GET_USER } from '../graphql/queries';

interface IUserContext {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
}

export const UserContext = React.createContext<IUserContext>({
  user: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUser: () => {},
});

interface UserContextProviderProps {
  children: React.ReactNode;
}

export function UserContextProvider({ children }: UserContextProviderProps) {
  const session = useSession();
  const [user, setUser] = React.useState<User>(null);

  const [getUser, { data, loading, error }] = useLazyQuery<{
    user: User;
  }>(GET_USER);

  const value = React.useMemo(() => ({ user, setUser }), [user]);

  React.useEffect(() => {
    if (session.status === 'authenticated') {
      const { expires } = session.data;
      getUser({
        variables: {
          filter: {
            _id: session.data.user._id,
          },
        },
      });
      // set local storage token
      localStorage.setItem('x-token-client', session.data.user.accessToken);
      localStorage.setItem('x-token-expiration', session.data.expires);

      // varify session expiration
      if (expires && new Date(expires).getTime() - new Date().getTime() < 0) {
        // sign out
        signOut();
      }

      // const expires = data.currentUser.user.;
      console.log('session', session);
    } else if (session.status === 'unauthenticated') {
      setUser(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.data?.user, session?.status]);

  React.useEffect(() => {
    if (!loading && !error && data && data?.user?.client) {
      setUser({ ...data.user });
    }
  }, [loading, JSON.stringify(error), JSON.stringify(data)]);

  return (
    <UserContext.Provider value={value}>
      {loading ? null : children}
    </UserContext.Provider>
  );
}
